import React from 'react';

export default function NotFound() {
   return(
      <div>Page not found 404</div>
   )
}